import React from 'react';
import { motion } from 'framer-motion';
import { HelpCircle } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Sirve si mi hijo acaba de ser diagnosticado?',
    a: 'Sí. El Tomo 1 está diseñado específicamente para padres que acaban de recibir el diagnóstico. Es tu punto de partida ideal.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después de la compra recibís un email con acceso a todos los PDFs. En menos de 5 minutos ya estás leyendo.'
  }, {
    q: '¿Funciona si mi hijo tiene TDAH combinado o solo inatento?',
    a: 'Sí. El contenido abarca los 3 tipos de TDAH con estrategias específicas para cada uno.'
  }, {
    q: '¿Qué diferencia tiene de buscar en Google o YouTube?',
    a: 'Google te da fragmentos sueltos sin sistema. Este combo es un método completo, ordenado, progresivo y listo para implementar hoy.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días. Devolución del 100% sin preguntas. Sin formularios. Sin drama.'
  }, {
    q: '¿Funciona si mi hijo tiene condiciones asociadas al TDAH?',
    a: 'Sí. El combo incluye estrategias para ansiedad, dificultades de aprendizaje, regulación emocional y problemáticas sociales frecuentemente asociadas.'
  }, {
    q: '¿Necesito conocimientos previos sobre TDAH?',
    a: 'No. El Tomo 1 parte desde cero y te lleva paso a paso hasta tener un panorama completo y un plan de acción claro.'
  }];
  return <section className="py-24 px-4 bg-slate-900" data-id="element-52">
      <div className="max-w-3xl mx-auto" data-id="element-53">
        <div className="text-center mb-16" data-id="element-54">
          <HelpCircle className="w-12 h-12 text-amber-400 mx-auto mb-4" data-id="element-55" />
          <h2 className="text-3xl md:text-4xl font-black text-white" data-id="element-56">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
        </div>

        <div className="space-y-4" data-id="element-57">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-slate-950 border border-slate-800 rounded-2xl p-6" data-id="element-58">
              <h3 className="text-lg font-bold text-white mb-2 flex items-start gap-3" data-id="element-59">
                <span className="text-amber-400 mt-1" data-id="element-60">+</span> {faq.q}
              </h3>
              <p className="text-slate-400 pl-6" data-id="element-61">{faq.a}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}